import { useMemo } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FaBell, FaRegBell } from "react-icons/fa";
import useNotifications from "../../../customHooks/useNotifications";

import "./dashboardNotifications.scss";

/*
 * Dashboard "التنبيهات" hub — unifies the page's live action prompts (passed as
 * children: eval / health / disciplinary) with the recent unread items from the
 * notification bell (GET /notifications), rendered as one consistent list.
 * "عرض الكل" links to the full notification center (/emp/nofications).
 */

// where a bell notification deep-links (mirrors NoficationsPage)
const resolveTarget = (notification) => {
  const data = notification.data || {};
  const eventType = data.event_type || "";
  const payload = data.payload || {};
  if (eventType.startsWith("objection")) return { path: "/emp/disciplinary-objections" };
  const caseId = payload.case_id;
  if (caseId) return { path: "/emp/disciplinary-case-details", caseId };
  return null;
};

const fmtDate = (d) => (d ? new Date(d).toLocaleDateString() : "");

function DashboardNotifications({ children }) {
  const navigate = useNavigate();
  const { data, markAsRead } = useNotifications({ page: 1, filters: { read: "unread" }, perPage: 5 });

  const bellItems = useMemo(() => (Array.isArray(data) ? data.slice(0, 4) : []), [data]);

  const handleClick = async (n) => {
    if (!n.read_at) await markAsRead(n.id);
    const target = resolveTarget(n);
    if (!target) return;
    if (target.caseId) {
      sessionStorage.setItem("disciplinary_case_id", target.caseId);
      navigate(target.path, { state: { id: target.caseId } });
    } else {
      navigate(target.path);
    }
  };

  return (
    <div className="dash-notif-hub">
      <div className="dash-notif-hub__head">
        <div className="dash-notif-hub__title">
          <FaBell className="dash-notif-hub__title-icon" />
          <span>التنبيهات</span>
        </div>
        <Link to="/emp/nofications" className="dash-notif-hub__all">عرض الكل</Link>
      </div>

      <div className="dash-notif-hub__list ds-stagger">
        {/* live action prompts computed on the page (eval / health / disciplinary) */}
        {children}

        {/* recent unread items from the notification bell, in the same list */}
        {bellItems.map((n) => {
          const d = n.data || {};
          const clickable = Boolean(resolveTarget(n));
          const cls =
            "dash-notif-row" +
            (n.read_at ? "" : " dash-notif-row--unread") +
            (clickable ? " dash-notif-row--clickable" : "");
          return (
            <div key={n.id} className={cls} onClick={() => handleClick(n)}>
              <span className="dash-notif-row__icon"><FaRegBell /></span>
              <div className="dash-notif-row__main">
                <div className="dash-notif-row__toprow">
                  <span className="dash-notif-row__title">{d.title_ar || "إشعار"}</span>
                  <span className="dash-notif-row__date">{fmtDate(n.created_at)}</span>
                </div>
                {d.body_ar && <p className="dash-notif-row__text">{d.body_ar}</p>}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default DashboardNotifications;
